export interface IAppInfo {
    Version: string;
    BuildNumber: string;
    ApplicationEnvironment: string;
    Branch: string;
    Commit: string;
    AppInsightsKey: string;
}

export const ApplicationInfo: IAppInfo = (window as any).appInfo;
